// The Drive folder behind a lead's requested file, reachable from the lead
// drawer (Henry, 2026-09-02: "you should be able to access the buyer folder
// in this screen"). The folder itself is born SERVER-side: requesting a file
// mints the hidden deal, functions-drive's onDealCreate trigger copies the
// template folder seconds later and stamps `driveFolderId` on that deal. So
// opening it is a read off the linked deal — with one recovery path: when the
// id is missing (trigger still running, or a request from before the Drive
// triggers were deployed), the same createDealFolder callable the Documents
// tab's "Create folder" button uses builds it on the spot.
import { getDealById } from "./firebasefunctions";
import { createDealFolder } from "./driveClient";

export const driveFolderUrl = (folderId) =>
  `https://drive.google.com/drive/folders/${folderId}`;

// Resolve the Drive folder id for a lead's linked file deal.
//   - "" when the lead has no linked file (nothing requested yet), or when
//     the folder isn't made yet and create is false (quiet prefetch mode).
//   - the folder id otherwise; create: true builds a missing folder.
// Throws a readable error when the linked deal itself is gone.
export async function resolveLeadFolderId(sourceDealId, { create = false } = {}) {
  if (!sourceDealId) return "";
  let deal;
  try {
    deal = await getDealById(String(sourceDealId));
  } catch {
    throw new Error("The file linked to this lead can't be found.");
  }
  if (deal?.driveFolderId) return deal.driveFolderId;
  if (!create) return "";
  return createDealFolder(String(sourceDealId));
}
